<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
  {
    key: 'carparkCode',
    text: 'Car Park Code',
  },
  {
    key: 'carparkName',
    text: 'Car Park Name',
  },
  {
    key: 'tenantType',
    text: 'Tenant Type',
  },
  {
    key: 'bayType',
    text: 'Bay Type',
  },
  {
    key: 'season',
    text: 'Product',
  },
  {
    key: 'amount',
    text: 'Amount',
  },
  {
    key: 'passes',
    text: 'Passes',
  },
  {
    key: 'total',
    text: 'Total',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportCarparkProduct",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Car Park Product' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageReport: null,

      showExportCSV: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadLicense() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading license data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/licenses/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageLicense = response.data;
            this.loadReport();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadReport() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);

      let feedbackItem = 'report data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/leases?startDate=' + startDate + '&stopDate=' + endDate + '&current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            response.data = response.data.filter(k => k.status === 'Active')
            this.pageReport = response.data;
            this.processReport();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    async processReport() {
      let leaseGroup = {};

      for(let index in this.pageReport) {
        let k = this.pageReport[index];

        let temp = leaseGroup[k.seasonID] = (leaseGroup[k.seasonID] || {
          passes: 0,
        });

        let license = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID']));

        temp['parkinglicense'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
        temp['season'] = k['seasonName'];
        temp['seasonID'] = k['seasonID'];
        let season = this.pageSeason.find(j => helper.compareID(j.id, k['seasonID']));
        if(!season) {
          return;
        }
        temp['tenantType'] = season.isTenant ? 'T' : 'NT';
        // { 2 : 'Reserved' },
        // { 3 : 'Tandem-Reserved' },
        // { 1 : 'Non-Reserved' },
        // { 4 : 'Motorcycle' },
        switch(k['bayType']) {
          case 1:
            temp['bayType'] = 'NR';
            break;
          case 2:
            temp['bayType'] = 'R';
            break;
          case 3:
            temp['bayType'] = 'TR';
            break;
          case 4:
            temp['bayType'] = 'M';
            break;
        }

        let seasonFees = this.pageSeasonFees[k['seasonID']];
        if(!seasonFees) {
          await this.$http
            .get(
              helper.SERVER_URL + '/api2/season/' + k['seasonID'] + '/currentSeasonFees/',
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              if(response.data && response.data.length > 0) {
                this.$refs['pageFeedback'].setFeedbackMessage();
                this.pageSeasonFees[k['seasonID']] = response.data[0];
              } else {
                this.$refs['pageFeedback'].setFeedbackError('No product data available.');
              }
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
            })
        }
        seasonFees = this.pageSeasonFees[k['seasonID']];
        
        temp['amount'] = seasonFees['monthly'];
        temp['passes']++;
      }

      let temp = [];
      let tempTotal = {amount: 0, passes: 0, total: 0, season: 'Sub Total'};
      for(let temp1 in leaseGroup) {
        let tempLease = leaseGroup[temp1];
        tempLease['total'] = tempLease['passes'] * tempLease['amount'];

        tempTotal['passes'] += tempLease['passes'];
        tempTotal['total'] += tempLease['total'];
        tempTotal['amount'] += tempLease['amount'];

        tempLease['amount'] = helper.formatMoney(tempLease['amount']);
        tempLease['total'] = helper.formatMoney(tempLease['total']);
        temp.push(tempLease);
      }
      tempTotal['amount'] = helper.formatMoney(tempTotal['amount']);
      tempTotal['total'] = helper.formatMoney(tempTotal['total']);
      temp.push(tempTotal);

      // TODO kw1 compare two months & average

      if(temp.length > 0) {
        let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue));
        temp[0]['carparkCode'] = carpark['id'];
        temp[0]['carparkName'] = carpark['name'];
      }

      this.$refs['pageTable'].setTableData(temp);
      this.showExportCSV = true;
    },


    // loadReport() {
    //   let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
    //   let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart.add('month', 1));

    //   let feedbackItem = 'report data';
    //   this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    //   this.$http
    //     .get(
    //       helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/leases?startDate=' + startDate + '&stopDate=' + endDate + '&current=1',
    //       helper.createAxiosConfig()
    //     )
    //     .then(response => {
    //       if(response.data && response.data.length > 0) {
    //         this.$refs['pageFeedback'].setFeedbackMessage();
    //         response.data = response.data.filter(k => k.status === 'Active')
    //         this.pageReport = response.data;
    //         this.processReport(1);
    //       } else {
    //         this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
    //       }
    //     })
    //     .catch(error => {
    //       this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
    //     })
    // },
    // loadReport2() {
    //   let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart.add('month', 1));
    //   let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);

    //   let feedbackItem = 'report data';
    //   this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    //   this.$http
    //     .get(
    //       helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/leases?startDate=' + startDate + '&stopDate=' + endDate + '&current=1',
    //       helper.createAxiosConfig()
    //     )
    //     .then(response => {
    //       if(response.data && response.data.length > 0) {
    //         this.$refs['pageFeedback'].setFeedbackMessage();
    //         response.data = response.data.filter(k => k.status === 'Active')
    //         this.pageReport = response.data;
    //         this.processReport(2);
    //       } else {
    //         this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
    //       }
    //     })
    //     .catch(error => {
    //       this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
    //     })
    // },

    // async processReport(test) {
    //   let leaseGroup = {};

    //   for(let index in this.pageReport) {
    //     let k = this.pageReport[index];

    //     let temp = leaseGroup[k.seasonID] = (leaseGroup[k.seasonID] || {
    //       passes: 0,
    //     });

    //     let license = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID']));

    //     temp['parkinglicense'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
    //     temp['season'] = k['seasonName'];
    //     temp['seasonID'] = k['seasonID'];
    //     let season = this.pageSeason.find(j => helper.compareID(j.id, k['seasonID']));
    //     if(!season) {
    //       return;
    //     }
    //     temp['tenantType'] = season.isTenant ? 'T' : 'NT';
    //     // { 2 : 'Reserved' },
    //     // { 3 : 'Tandem-Reserved' },
    //     // { 1 : 'Non-Reserved' },
    //     // { 4 : 'Motorcycle' },
    //     switch(k['bayType']) {
    //       case 1:
    //         temp['bayType'] = 'NR';
    //         break;
    //       case 2:
    //         temp['bayType'] = 'R';
    //         break;
    //       case 3:
    //         temp['bayType'] = 'TR';
    //         break;
    //       case 4:
    //         temp['bayType'] = 'M';
    //         break;
    //     }

    //     let seasonFees = this.pageSeasonFees[k['seasonID']];
    //     if(!seasonFees) {
    //       await this.$http
    //         .get(
    //           helper.SERVER_URL + '/api2/season/' + k['seasonID'] + '/currentSeasonFees/',
    //           helper.createAxiosConfig()
    //         )
    //         .then(response => {
    //           if(response.data && response.data.length > 0) {
    //             this.$refs['pageFeedback'].setFeedbackMessage();
    //             this.pageSeasonFees[k['seasonID']] = response.data[0];
    //           } else {
    //             this.$refs['pageFeedback'].setFeedbackError('No product data available.');
    //           }
    //         })
    //         .catch(error => {
    //           this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
    //         })
    //     }
    //     seasonFees = this.pageSeasonFees[k['seasonID']];
        
    //     temp['amount'] = seasonFees['monthly'];
    //     temp['passes']++;
    //   }

    //   let temp = [];
    //   let tempTotal = {amount: 0, passes: 0, total: 0, season: 'Sub Total'};
    //   for(let temp1 in leaseGroup) {
    //     let tempLease = leaseGroup[temp1];
    //     tempLease['total'] = tempLease['passes'] * tempLease['amount'];

    //     tempTotal['passes'] += tempLease['passes'];
    //     tempTotal['total'] += tempLease['total'];
    //     tempTotal['amount'] += tempLease['amount'];

    //     tempLease['amount'] = helper.formatMoney(tempLease['amount']);
    //     tempLease['total'] = helper.formatMoney(tempLease['total']);
    //     temp.push(tempLease);
    //   }
    //   tempTotal['amount'] = helper.formatMoney(tempTotal['amount']);
    //   tempTotal['total'] = helper.formatMoney(tempTotal['total']);
    //   temp.push(tempTotal);

    //   if(test === 1) {
    //     this.pageReport1 = temp;
    //   } else {
    //     this.pageReport2 = temp;
    //     this.processReportUltimate();
    //   }
    // },
    // processReportUltimate() {
    //   // TODO kw1 merge report 1 and report 2 then average
    //   let finalReport = {};
    //   this.pageReport1.forEach(report => {
    //     finalReport[report[seasonID]]
    //   })
      
    //   if(temp.length > 0) {
    //     let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue));
    //     temp[0]['carparkCode'] = carpark['id'];
    //     temp[0]['carparkName'] = carpark['name'];
    //   }

    //   this.$refs['pageTable'].setTableData(temp);
    //   this.showExportCSV = true;
    // },

    getUrl(licenseID) {
      let url = helper.SERVER_URL + '/api2';
      if(licenseID) {
        url += '/licenses/' + licenseID;
      }
      url += '/unpaidbills/';

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadSeason();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadReport();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'paymethodID') {
        let paymentMethod = formData[formParameter.key];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
        } else { 
          // cash?
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        }
      } else if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID'])
        formData['staffNo'] = staff['personnelCode'];
      }
    },
    onCSVButtonClick() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);
      printCSV('#jt-table', `Report Customer Fees ${startDate} - ${endDate}`);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportCarparkProduct.vue